/* eslint-disable no-restricted-globals */
// From https://github.com/Raynos/global/blob/master/window.js
let win

if (typeof window !== 'undefined') {
  win = window
} else if (typeof global !== 'undefined') {
  win = global
} else if (typeof self !== 'undefined') {
  win = self
} else {
  win = {}
}

export default win
